import { IPost } from "../types/IPost";

export const MOCK_POSTS: IPost[] = [
  {
    id: 1,
    title: 'Worth A Thousand Words',
    slug: 'worth-a-thousand-words',
    href: '/blog/worth-a-thousand-words',
    dateISO: '2008-10-17',
    dateText: 'Oct 17, 2008',
    author: { name: 'Andrea Lopez', href: '/author/theme-admin' },
    categories: [{ name: 'Uncategorized', href: '/category/uncategorized' }],
    tags: [{ name: 'boat', href: '/tag/boat' }, { name: 'lake', href: '/tag/lake' }],
    excerpt: 'Boat.',
    content: ['Boat content. Lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing, and web development. Its purpose is to permit a page layout to be designed, independently of the copy that will subsequently populate it, or to demonstrate various fonts of a typeface without meaningful text that could be distracting. Lorem ipsum is typically a corrupted version of De finibus bonorum et malorum, a 1st-century BC text by the Roman statesman and philosopher Cicero, with words altered, added, and removed to make it nonsensical and improper Latin.Lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing, and web development. Its purpose is to permit a page layout to be designed, independently of the copy that will subsequently populate it, or to demonstrate various fonts of a typeface without meaningful text that could be distracting. Lorem ipsum is typically a corrupted version of De finibus bonorum et malorum, a 1st-century BC text by the Roman statesman and philosopher Cicero, with words altered, added, and removed to make it nonsensical and improper Latin']
  }
  // ,
  // {
  //   id: 2,
  //   title: 'Elements',
  //   slug: 'elements',
  //   href: '/blog/elements',
  //   dateISO: '2008-09-05',
  //   dateText: 'Sep 5, 2008',
  //   author: { name: 'Andrea Lopez', href: '/author/theme-admin' },
  //   categories: [{ name: 'Uncategorized', href: '/category/uncategorized' }],
  //   tags: [{ name: 'wordpress', href: '/tag/wordpress' }],
  //   excerpt: 'The purpose of this HTML is to help determine what default settings are with CSS...',
  //   content: ['Paragraph example']
  // },
  // {
  //   id: 3,
  //   title: 'More Tags',
  //   slug: 'more-tags',
  //   href: '/blog/more-tags',
  //   dateISO: '2008-06-21',
  //   dateText: 'Jun 21, 2008',
  //   author: { name: 'Andrea Lopez', href: '/author/theme-admin' },
  //   categories: [{ name: 'Uncategorized', href: '/category/uncategorized' }],
  //   tags: [{ name: 'wordpress', href: '/tag/wordpress' }],
  //   excerpt: 'More of these posts need tags.',
  //   content: ['Tag content']
  // },
  // {
  //   id: 4,
  //   title: 'HTML',
  //   slug: 'html',
  //   href: '/blog/html',
  //   dateISO: '2008-06-21',
  //   dateText: 'Jun 21, 2008',
  //   author: { name: 'Andrea Lopez', href: '/author/theme-admin' },
  //   categories: [{ name: 'Uncategorized', href: '/category/uncategorized' }],
  //   tags: [{ name: 'html', href: '/tag/html' }, { name: 'wordpress', href: '/tag/wordpress' }],
  //   excerpt: 'What HTML tags would you like to see?',
  //   content: ['HTML content']
  // },
  // {
  //   id: 5,
  //   title: 'Links',
  //   slug: 'links',
  //   href: '/blog/links',
  //   dateISO: '2008-06-20',
  //   dateText: 'Jun 20, 2008',
  //   author: { name: 'Andrea Lopez', href: '/author/theme-admin' },
  //   categories: [{ name: 'Uncategorized', href: '/category/uncategorized' }],
  //   tags: [{ name: 'links', href: 'tag/links' }],
  //   excerpt: 'A few well known WordPress links.',
  //   content: ['Links content']
  // },
  //   {
  //   id: 6,
  //   title: 'Links',
  //   slug: 'links0',
  //   href: '/blog/links',
  //   dateISO: '2008-06-20',
  //   dateText: 'Jun 20, 2008',
  //   author: { name: 'Andrea Lopez', href: '/author/theme-admin' },
  //   categories: [{ name: 'Uncategorized', href: '/category/uncategorized' }],
  //   tags: [{ name: 'links', href: 'tag/links' }],
  //   excerpt: 'A few well known WordPress links.',
  //   content: ['Links content']
  // },
  //   {
  //   id: 7,
  //   title: 'Links',
  //   slug: 'links1',
  //   href: '/blog/links',
  //   dateISO: '2008-06-20',
  //   dateText: 'Jun 20, 2008',
  //   author: { name: 'Andrea Lopez', href: '/author/theme-admin' },
  //   categories: [{ name: 'Uncategorized', href: '/category/uncategorized' }],
  //   tags: [{ name: 'links', href: 'tag/links' }],
  //   excerpt: 'A few well known WordPress links.',
  //   content: ['Links content']
  // },
  //   {
  //   id: 8,
  //   title: 'Links',
  //   slug: 'links2',
  //   href: '/blog/links',
  //   dateISO: '2008-06-20',
  //   dateText: 'Jun 20, 2008',
  //   author: { name: 'Andrea Lopez', href: '/author/theme-admin' },
  //   categories: [{ name: 'Uncategorized', href: '/category/uncategorized' }],
  //   tags: [{ name: 'links', href: 'tag/links' }],
  //   excerpt: 'A few well known WordPress links.',
  //   content: ['Links content']
  // },
  
];
